export default "__VITE_ASSET__f8dc0640__"